import { render, staticRenderFns } from "./NotesPrivacyPolicy.vue?vue&type=template&id=5433e3a1"
import script from "./NotesPrivacyPolicy.vue?vue&type=script&lang=js"
export * from "./NotesPrivacyPolicy.vue?vue&type=script&lang=js"
import style0 from "./NotesPrivacyPolicy.vue?vue&type=style&index=0&id=5433e3a1&prod&lang=scss"


/* normalize component */
import normalizer from "!../../../../../node_modules/vue-loader/lib/runtime/componentNormalizer.js"
var component = normalizer(
  script,
  render,
  staticRenderFns,
  false,
  null,
  null,
  null
  
)

export default component.exports